import React, { useState } from 'react';
import { BookOpen, X } from 'lucide-react';
import { useStore } from '../store';

export default function AboutComponent() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isModelAnimationComplete = useStore((state) => state.isModelAnimationComplete);

  return (
    <div>
      {/* Lookbook Button */}
      {isModelAnimationComplete && (
        <div className="fixed z-50 lg:bottom-40 bottom-40 left-1/2 transform -translate-x-1/2 opacity-0 animate-fade-in">
          <button
            onClick={() => setIsDialogOpen(true)}
            className="relative group bg-pink-200 text-pink-400 px-8 py-2.5 rounded-lg 
              hover:bg-pink-400 hover:text-pink-200 transition-all duration-300 min-w-[250px]
              flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
          >
            <BookOpen className="w-5 h-5" />
            About
          </button>
        </div>
      )}

      {/* Lookbook Modal */}
      {isDialogOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] 
            flex items-center justify-center p-4"
          onClick={() => setIsDialogOpen(false)}
        >
          <div
            className="bg-white/50 rounded-xl w-full max-w-4xl h-[80vh] flex flex-col
              shadow-2xl relative overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsDialogOpen(false)}
              className="absolute top-4 right-4 z-[20] text-gray-500 hover:text-gray-800
                bg-white/80 rounded-full p-1"
            >
              <X className="w-6 h-6" />
            </button>

            {/* Content Area */}
            <div className="flex-1 overflow-hidden relative">
              {/* paragraph */}
              <div className="h-full w-full relative bg-white">
            
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}